import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "p-grid"
}
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-mr-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-6 p-pl-6" }, [
  /*#__PURE__*/_createElementVNode("h3", null, " Registro de actividad ")
], -1)
const _hoisted_5 = { class: "p-col-6 p-d-flex p-jc-end p-pr-6 p-ai-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "p-grid" }
const _hoisted_9 = { class: "p-col-12" }
const _hoisted_10 = { class: "p-col-12" }
const _hoisted_11 = { class: "p-grid custom-header" }
const _hoisted_12 = { class: "p-col-fixed p-as-center" }
const _hoisted_13 = { class: "p-col-fixed header p-as-center" }
const _hoisted_14 = {
  key: 0,
  class: "p-col p-d-flex p-jc-center"
}
const _hoisted_15 = {
  key: 0,
  class: "p-col-fixed"
}
const _hoisted_16 = {
  key: 1,
  class: "p-col-fixed"
}
const _hoisted_17 = {
  key: 2,
  class: "p-col-fixed"
}
const _hoisted_18 = {
  key: 3,
  class: "p-col-fixed"
}
const _hoisted_19 = {
  key: 1,
  class: "p-col-fixed p-text-right p-as-center"
}
const _hoisted_20 = { class: "p-grid" }
const _hoisted_21 = { class: "p-col" }
const _hoisted_22 = { class: "p-col" }
const _hoisted_23 = {
  key: 0,
  class: "indicator pi pi-arrow-down"
}
const _hoisted_24 = {
  key: 1,
  class: "indicator pi pi-arrow-up"
}
const _hoisted_25 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass([
                                                    'title p-col-3 p-text-right'
                                                ])
}
const _hoisted_26 = { class: "p-grid" }
const _hoisted_27 = { class: "p-col-12" }
const _hoisted_28 = { class: "p-grid" }
const _hoisted_29 = { class: "p-col" }
const _hoisted_30 = { class: "p-grid" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, " 12/10/2021 ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, " Mitad de comision ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-2 aux" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-grid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 custom-line" }),
    /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" })
  ])
], -1)
const _hoisted_34 = { class: "p-col-9" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("12/10/2021")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Email enviado ")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "p-col p-text-right" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ModuleHeader = _resolveComponent("ModuleHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_EmailSending = _resolveComponent("EmailSending")!
  const _component_AddRegister = _resolveComponent("AddRegister")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_spam = _resolveComponent("spam")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.errorRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ModuleHeader, null, {
              title: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.teacherActivity[0].userInfo.profile ? `${_ctx.teacherActivity[0].userInfo.profile.firstName} ${_ctx.teacherActivity[0].userInfo.profile.lastName}` : '--'), 1)
              ]),
              _: 1
            })
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isReinfo === `true`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRegisterlModal())),
                    class: "p-button-link",
                    icon: "pi pi-plus",
                    label: "Enviar registro"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_Button, {
                    class: "p-button-link",
                    icon: "pi pi-exclamation-triangle",
                    label: "Enviar a refuerzo"
                  })
                ])),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEmailModal())),
                class: "p-button-link",
                icon: "pi pi-envelope",
                label: "Enviar email"
              }),
              _createVNode(_component_EmailSending, {
                tracingInfo: _ctx.tracingEmail,
                visible: _ctx.emailModal,
                setMail: _ctx.emailInfo,
                contextId: 'emails.activity-record'
              }, null, 8, ["tracingInfo", "visible", "setMail", "contextId"]),
              _createVNode(_component_AddRegister, {
                onOnClose: _ctx.showRegisterlModal,
                StaffTracing: _ctx.SelectedTracing,
                visible: _ctx.registerModal
              }, null, 8, ["onOnClose", "StaffTracing", "visible"])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teacherActivity, (info) => {
            return (_openBlock(), _createElementBlock("div", {
              key: info,
              class: "p-col-12 p-pr-6 p-pl-6 p-pb-2"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Card, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(info.levelInfo? info.levelInfo.title : '--'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Accordion, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_AccordionTab, null, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_Checkbox, {
                                value: info,
                                name: "info",
                                modelValue: _ctx.SelectedTracing,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.SelectedTracing = $event))
                              }, null, 8, ["value", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(info.camadaInfo? info.camadaInfo.id : '--'), 1),
                            (info.tracingTags !== undefined && _ctx.isReinfo === `true`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (info.tracingTags.neutral.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createVNode(_component_Tag, {
                                          style: {"color":"black"},
                                          class: _normalizeClass(['p-tag-yellow-brain'])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(info.tracingTags.neutral[0].value), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (info.tracingTags.neutral.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createVNode(_component_Tag, {
                                          style: {"color":"black"},
                                          class: _normalizeClass(['p-tag-yellow-brain'])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(info.tracingTags.neutral[0].title), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (info.tracingTags.negative.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createVNode(_component_Tag, {
                                          style: {"color":"black"},
                                          class: _normalizeClass(['p-tag-red-brain'])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(info.tracingTags.negative[0].value), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (info.tracingTags.negative.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createVNode(_component_Tag, {
                                          style: {"color":"black"},
                                          class: _normalizeClass(['p-tag-red-brain'])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(info.tracingTags.negative[0].title), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (info.rating[0] !== undefined || null && _ctx.isReinfo === `true`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass([
                                                'p-col',
                                                info.rating[0].value >= 4.7 ? 'positive-rate' : 'negative-rate'
                                                ])
                                    }, _toDisplayString(info.rating[0].value), 3),
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(info.rating[0].variation), 1),
                                    _createElementVNode("div", _hoisted_22, [
                                      (info.rating[0].variation < 0)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                                        : (info.rating[0].variation > 0)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_25))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _hoisted_31,
                                    _hoisted_32,
                                    _hoisted_33,
                                    _createElementVNode("div", _hoisted_34, [
                                      _createVNode(_component_spam, null, {
                                        default: _withCtx(() => [
                                          _hoisted_35
                                        ]),
                                        _: 1
                                      }),
                                      _hoisted_36
                                    ])
                                  ])
                                ]),
                                _hoisted_37
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}